class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('#CartDrawer');
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setCloseEvents();
  }

  setCloseEvents() {
    this.querySelector('.cart-drawer-close').addEventListener('click', this.close.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    if(document.body.dataset.pageType !== 'cart') {
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.drawer.style.transform = 'translateX(0)';
    this.overlay.classList.remove('invisible');
    this.overlay.classList.remove('pointer-events-none');
    this.overlay.classList.remove('opacity-0');

    this.drawer.addEventListener('transitionend', () => {
      
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.drawer.style.transform = 'translateX(100%)';
    document.body.classList.remove('overflow-hidden');
    this.overlay.classList.add('invisible');
    this.overlay.classList.add('pointer-events-none');
    this.overlay.classList.add('opacity-0');
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(parsedState.sections[section.id] !== null) {
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
    this.setCloseEvents();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = 'cart-drawer') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer-Content',
        section: 'cart-drawer',
        selector: '#CartDrawer-Content'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);